<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <!-- Page Header: start -->
          <div class="md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
              <h2 class="text-2xl font-light leading-7 text-gray-900 sm:text-2xl sm:leading-9 sm:truncate">
                Neue Frage
              </h2>
            </div>
            <div class="mt-4 flex md:mt-0 md:ml-4">
              <span class="sm:ml-3 shadow-sm rounded-md">
                <Link :href="route('admin.questions.index')"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-500 bg-gray-300 shadow-sm hover:bg-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400">
                Übersicht</Link>
              </span>
            </div>
          </div>
          <!-- Page Header: end -->

          <horizontal-divider />

          <form @submit.prevent="submit" novalidate>
            <div>
              <div class="md:grid md:grid-cols-3 md:gap-6">
                <div class="md:col-span-1">
                  <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                      Frage
                    </h3>
                    <p class="mt-1 text-sm leading-5 text-gray-600"></p>
                  </div>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                  <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white sm:p-6">
                      <div class="grid grid-cols-3 gap-6">
                        <div class="col-span-6 sm:col-span-4">
                          <label for="question"
                            class="block text-sm font-medium leading-5 text-gray-700">Standard-Frage</label>
                          <textarea id="question" v-model="form.question" :disabled="form.processing" rows="3"
                            class="shadow-sm focus:ring-gray-400 focus:border-gray-400 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                        </div>

                        <placeholder-question :question="null" @questionChanged="placeholderQuestionChanged" :processing="form.processing"></placeholder-question>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <horizontal-divider />

            <question-type :question="null" :question-types="question_types"
            @questionTypeChanged="questionTypeChanged"
            :processing="form.processing"></question-type>

            <horizontal-divider />

            <partner :question="null" :partners="partners" @partnersChanged="partnersChanged"></partner>


            <div class="mt-8 border-t border-gray-200 pt-5">
              <div class="flex justify-end">
                <submit-button :sending="form.processing" :validated="validated"
                  :full-width="false">Speichern</submit-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import SubmitButton from '@/Shared/SubmitButton.vue';
import PlaceholderQuestion from '@/Pages/Questions/Shared/PlaceholderQuestion.vue';
import QuestionType from '@/Pages/Questions/Shared/QuestionType.vue';
import Partner from '@/Pages/Questions/Shared/Partner.vue';

export default {
  metaInfo: { title: 'Neue Frage' },

  components: {
    Layout,
    HorizontalDivider,
    SubmitButton,
    PlaceholderQuestion,
    QuestionType,
    Partner,
  },

  props: {
    partners: Array,
    question_types: Array,
  },

  data() {
    return {
      form: this.$inertia.form({
        question: '',
        placeholder_question: '',
        question_type: '',
        classification_type: '',
        partner_ids: [],

        parameters: {
          keywords: {
            keywords: 3,
            placeholder: '',
          },
          textblock_multiple: {
            max_answers: 3,
          },
          rating: {
            max: 10,
          },
        },
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('admin.questions.store'), {});
    },

    placeholderQuestionChanged(question) {
      this.form.placeholder_question = question;
    },

    questionTypeChanged(question) {
      this.form.question_type = question.question_type;
      this.form.classification_type = question.classification_type;
      this.form.parameters = question.parameters;
      // console.log(question);
    },

    partnersChanged(partner_ids) {
      this.form.partner_ids = partner_ids;
    },
  },

  computed: {
    validated() {
      return (
        this.form.question.length > 0 && this.form.question_type && this.form.classification_type
      );
    },
  },
};
</script>
